import { render } from "./KDSLayout.vue?vue&type=template&id=467f001b"
import script from "./KDSLayout.vue?vue&type=script&lang=js"
export * from "./KDSLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__